import { render, staticRenderFns } from "./ContentCreationCard.vue?vue&type=template&id=b0dde8ca"
import script from "./ContentCreationCard.vue?vue&type=script&lang=js"
export * from "./ContentCreationCard.vue?vue&type=script&lang=js"
import style0 from "./ContentCreationCard.vue?vue&type=style&index=0&id=b0dde8ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports